import type { ScanLive } from '../../api/admScanLive'

/**
 * Banda scanarilor in curs de deasupra listei - `paintStrip()` din adm.js,
 * cu clasele din adm.css (`.adm-live`, `.adm-live-card`, `.adm-progress`).
 * Fiecare scanare vie: releul, bara cu "responded of total", cate CI-uri a
 * facut si cate tinte au picat, si legatura spre fisa ei. Una incheiata
 * ramane cu "refresh the list": randurile din tabel sunt de dinaintea
 * scanarii, si reincarcarea o cere omul, nu pagina - altfel i s-ar smuci
 * ecranul sub ochi.
 */
export function ScanLiveStrip({ live, onReload }: { live: ScanLive; onReload: () => void }) {
  const ids = Object.keys(live.runs).map(Number)
  if (ids.length === 0 && live.note === '') return null
  return (
    <div className="adm-live" id="admLive">
      {live.note !== '' ? (
        <div className="adm-live-card adm-live-done">
          <span className="adm-live-note">{live.note}</span>
        </div>
      ) : null}
      {ids.map((id) => {
        const run = live.runs[id]!
        const done = run.state !== 1 && run.state !== 2
        const pc = run.total > 0 ? Math.min(100, Math.round((run.responded / run.total) * 100)) : 0
        return (
          <div key={id} className={`adm-live-card${done ? ' adm-live-done' : ''}`} data-run={id}>
            <span className="adm-live-title">
              {done ? 'Finished' : <><i className="fas fa-sync fa-spin"></i> Scanning</>} &middot; {run.relay || `run #${id}`}
            </span>
            <div className="adm-progress">
              <span style={{ width: `${pc}%` }}></span>
              <em>
                {run.responded} of {run.total} responded ({pc}%)
              </em>
            </div>
            <span className="adm-live-note">
              {run.created} created{run.errors > 0 ? ` · ${run.errors} failed` : ''}
            </span>
            <a href={`/app/adm/run/${id}`}>open</a>
            {done ? (
              <>
                {' '}
                <a
                  href="#"
                  className="admLiveReload"
                  onClick={(e) => {
                    e.preventDefault()
                    onReload()
                  }}
                >
                  refresh the list
                </a>
              </>
            ) : null}
          </div>
        )
      })}
      <span className="adm-live-note-off" id="admLiveNote" hidden={live.watching} title="The live channel is not connected, so these numbers are refreshed every 15 seconds instead of as they happen.">
        refreshed every 15 seconds
      </span>
    </div>
  )
}
